import React from "react";
import Grid from "@material-ui/core/Grid";
import Aux from "../../../../hoc/Auxiliary/Auxiliary";
import {translation} from "../../../../I18n/i18n";

const PersonalInformationRead = (props) => {
    function computeLabel(code) {
        switch (code) {
            case "M" :
                return translation(props.lang, "Male");
            case "F" :
                return translation(props.lang, "Female");
            case "" :
                return translation(props.lang, "Do not indicate");
            default:
                return translation(props.lang, "Do not indicate");

        }
    }

    return (
        <Aux>

            <br/>
            <Grid container>
                <Grid item xs={3}>
                <span
                    className=" MuiCardHeader-title ">Email</span>
                </Grid>
                <Grid item xs={9}>
                    <span
                        style={{'color': 'rgba(0, 0, 0, 0.54)'}}>{props.element.Identification.ContactInfo.Email.Contact._text}</span>
                </Grid>

            </Grid>
            <br/>
            <Grid container>
                <Grid item xs={3}>
                <span
                    className=" MuiCardHeader-title ">{translation(props.lang, "First name")}</span>
                </Grid>
                <Grid item xs={9}>
                <span
                    style={{'color': 'rgba(0, 0, 0, 0.54)'}}>{props.element.Identification.PersonName.FirstName._text}</span>
                </Grid>

            </Grid>
            <br/>
            <Grid container>
                <Grid item xs={3}>
                <span
                    className=" MuiCardHeader-title ">{translation(props.lang, "Last name")}</span>
                </Grid>
                <Grid item xs={9}>
                <span
                    style={{'color': 'rgba(0, 0, 0, 0.54)'}}>{props.element.Identification.PersonName.Surname._text}</span>
                </Grid>

            </Grid>
            <br/>
            <Grid container>
                <Grid item xs={3}>
                <span
                    className=" MuiCardHeader-title ">{translation(props.lang, "Function")}</span>
                </Grid>
                <Grid item xs={9}>
                <span
                    style={{'color': 'rgba(0, 0, 0, 0.54)'}}>{props.element.Headline.Description.Label._text}</span>
                </Grid>

            </Grid>
            <br/>
            <Grid container>
                <Grid item xs={3}>
                <span
                    className=" MuiCardHeader-title ">{translation(props.lang, "Gender")}</span>
                </Grid>
                <Grid item xs={9}>
                <span
                    style={{'color': 'rgba(0, 0, 0, 0.54)'}}>{computeLabel(props.element.Identification.Demographics.Gender.Code._text)}</span>
                </Grid>

            </Grid>

        </Aux>
    );
};

export default PersonalInformationRead;
